import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AppConfig } from 'src/app/api/helper/app.config';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Auftragstyp } from 'src/app/api/model/swagger-model';
import { TourService } from 'src/app/api/tour.service';

const log = new Logger("AuftragslisteKarteMenuPopoverComponent");

@Component({
    template: `
    <ion-list>
        <ng-container *ngIf="tourLadenVerfuegbar">
            <ion-item button appClick (clicked)="onTourLaden()" lines="none">{{ 'Tour laden' | translate }}</ion-item>
            <ion-item button [disabled]="entladenDisabled" appClick (clicked)="onTourEntladen()" lines="none">{{ 'Tour entladen' | translate }}</ion-item>
            
            <ion-item-divider></ion-item-divider>
        </ng-container>

        <ion-item button *ngIf="tourStartVerfuegbar" appClick (clicked)="onTourStarten()" lines="none">{{ 'Tour starten' | translate }}</ion-item>
        <ion-item button *ngIf="tourEndeVerfuegbar" appClick (clicked)="onTourBeenden()" lines="none">{{ 'Tour beenden' | translate }}</ion-item>
        <ion-item button *ngIf="sortierenVerfuegbar" appClick (clicked)="onSortieren()" lines="none">{{ 'Sortieren' | translate }}</ion-item>
    </ion-list>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragslisteKarteMenuPopoverComponent implements OnInit, OnChanges {

    @Input() auftragstyp: Auftragstyp;
    @Input() auftragAnlegenErlaubt: boolean;

    tourStartVerfuegbar = false;
    entladenDisabled = !MyApp.current.aktuellGeladeneTour.getValue();
    tourLadenVerfuegbar = AppConfig.current.einstellungen.TourLadenVerfuegbar === 'ja';
    tourEndeVerfuegbar = false;

    sortierenVerfuegbar = false;

    app = MyApp.current;

    constructor(
        private router: Router,
        private auftragService: AuftragService,
        private popoverController: PopoverController,
        private tourService: TourService,
        protected cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.init();

        if (this.auftragstyp === Auftragstyp.Transportauftrag) {
            if (this.app.tourStartenErforderlich.getValue()) {
                if (this.app.tourGestartet.getValue()) {
                    this.tourEndeVerfuegbar = AppConfig.current.einstellungen.MenueAuftragslisteTourEnde === 'ja';
                } else {
                    this.tourStartVerfuegbar = AppConfig.current.einstellungen.MenueAuftragslisteTourStart === 'ja';
                }
            }

            this.sortierenVerfuegbar = AppConfig.current.einstellungen.TransportauftragSortieren === 'ja';
        } else if (this.auftragstyp === Auftragstyp.Hofchecker) {
            this.sortierenVerfuegbar = AppConfig.current.einstellungen.HofauftragSortieren === 'ja';
        }

        this.entladenDisabled = !MyApp.current.aktuellGeladeneTour.getValue();
    }

    init() {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onTourLaden() {
        log?.debug('onTourLaden');
        this.popoverController.dismiss('tour-laden');
    }

    async onTourEntladen() {
        log?.debug('onTourEntladen');

        const tour = MyApp.current.aktuellGeladeneTour.getValue();

        if (!tour) {
            return;
        }

        const ok = await UiHelper.confirmJaNein(`Tour ${tour.Key} wirklich entladen?`);

        if (ok) {
            this.popoverController.dismiss('tour-entladen');

            await this.tourService.entladeGeladeneTour();
        }
    }

    onTourStarten() {
        log?.debug('onTourStarten');
        this.popoverController.dismiss('tour-starten');
    }

    onTourBeenden() {
        log?.debug('onTourBeenden');
        this.popoverController.dismiss('tour-beenden');
    }

    onArchivAnzeigen() {
        log?.debug('onArchivAnzeigen');
        this.popoverController.dismiss('archiv-anzeigen');
    }

    onAktuelleAuftraegeAnzeigen() {
        log?.debug('onAktuelleAuftraegeAnzeigen');
        this.popoverController.dismiss('aktuelle-auftraege-anzeigen');
    }

    onSortieren() {
        log?.debug('onSortieren');
        this.popoverController.dismiss('auftraege-sortieren');
    }

    onNeuerAuftrag() {
        log?.debug('onNeuerAuftrag');
        this.popoverController.dismiss('neuer-auftrag');
    }
}
